import { computed, ref } from "vue";
import { createRouter, createWebHistory, useRoute } from "vue-router";
import { clearModal, setIsLoading, state as stateApp } from "../app.logic";
import { createRoutedMap, state as stateAppLayout } from "../components/layout/app-layout/app-layout.logic";
import i18n from "../i18n";
import store from "../store";
import { matchMenu } from "../utils/menu-context";

const RouteView = {
    render: () => <router-view></router-view>
};

const routeData = [
    {
        path: "",
        name: "index",
        redirect: { name: "app" }
    },
    {
        path: "/app",
        name: "app",
        redirect: { name: "home" },
        component: () => import("../components/layout/app-layout/AppLayout"),
        children: [
            {
                path: "home",
                name: "home",
                // component: () => import("../views/app/home/Home"),
                component: () => import("../views/menu-list/MenuList"),
            },
            {
                path: "profile",
                redirect: { name: "profile" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "profile",
                        component: () => import("../views/app/profile/ProfileForm")
                    }
                ]
            },
            {
                path: "user-signatures",
                redirect: { name: "user-signatures" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "user-signatures",
                        component: () => import("../views/app/user-signature/UserSignatureForm"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                    }
                ]
            },
            {
                path: "user-insteads",
                redirect: { name: "user-insteads" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "user-insteads",
                        component: () => import("../views/app/user-instead/UserInsteadList"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: "create",
                        name: "user-insteads-create",
                        component: () => import("../views/app/user-instead/UserInsteadForm"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: ":id/edit",
                        name: "user-insteads-edit",
                        component: () => import("../views/app/user-instead/UserInsteadForm"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: ":id/view",
                        name: "user-insteads-view",
                        component: () => import("../views/app/user-instead/UserInsteadForm"),
                        props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    }
                ]
            },
            {
                path: "notifications",
                redirect: { name: "notifications" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "notifications",
                        component: () => import("../views/app/notification/NotificationList")
                    }
                ]
            },
            {
                path: "data-mgt",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "data-mgt",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "departments",
                        redirect: { name: "departments" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "departments",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "departments-create",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "departments-edit",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "departments-view",
                                component: () => import("../views/app/setting/data-mgt/department/DepartmentForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "lookups",
                        redirect: { name: "lookups" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "lookups",
                                component: () => import("../views/app/setting/data-mgt/lookup/LookupIconList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":group",
                                component: {
                                    render: () => <router-view></router-view>,
                                    setup() {
                                        const route = useRoute();
                                        const { createGroupTitle } = require("../views/app/setting/data-mgt/lookup/lookup.logic");
                                        const group = route.params.group;
                                        const title = computed(() => createGroupTitle({ group }));
                                        return { title };
                                    }
                                },
                                children: [
                                    {
                                        path: "",
                                        name: "lookups-group",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupList"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: "create",
                                        name: "lookups-create",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "lookups-edit",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "lookups-view",
                                        component: () => import("../views/app/setting/data-mgt/lookup/LookupForm"),
                                        props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                path: "events",
                redirect: { name: "events" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "events",
                        component: () => import("../views/app/event/EventList")
                    },
                    {
                        path: ":id/view",
                        name: "events-view",
                        component: () => import("../views/app/event/EventForm"),
                        props: { viewOnly: true }
                    }
                ]
            },
            {
                path: "entity-logs",
                redirect: { name: "entity-logs" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "entity-logs",
                        component: () => import("../views/app/entity-log/EntityLogList")
                    }
                ]
            },
            {
                path: "security-events",
                redirect: { name: "security-events" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "security-events",
                        component: () => import("../views/app/security-event/SecurityEventList")
                    },
                    {
                        path: ":id/view",
                        name: "security-events-view",
                        component: () => import("../views/app/security-event/SecurityEventForm"),
                        props: { viewOnly: true }
                    }
                ]
            },
            {
                path: "service-logs",
                redirect: { name: "service-logs" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "service-logs",
                        component: () => import("../views/app/service-log/ServiceLogList")
                    }
                ]
            },
            {
                path: "setting",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "setting",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "user-mgt",
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "user-mgt",
                                component: () => import("../views/menu-list/MenuList"),
                                meta: { isAuth: true }
                            },
                            {
                                path: "users",
                                redirect: { name: "users" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "users",
                                        component: () => import("../views/app/setting/user-mgt/user/UserList"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: "create",
                                        name: "users-create",
                                        component: () => import("../views/app/setting/user-mgt/user/UserForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "users-edit",
                                        component: () => import("../views/app/setting/user-mgt/user/UserForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "users-view",
                                        component: () => import("../views/app/setting/user-mgt/user/UserForm"),
                                        props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    }
                                ]
                            },
                            {
                                path: "roles",
                                redirect: { name: "roles" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "roles",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleList"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: "create",
                                        name: "roles-create",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "roles-edit",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "roles-view",
                                        component: () => import("../views/app/setting/user-mgt/role/RoleForm"),
                                        props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    }
                                ]
                            },
                            {
                                path: "resources",
                                redirect: { name: "resources" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "resources",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceList"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: "create",
                                        name: "resources-create",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "resources-edit",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "resources-view",
                                        component: () => import("../views/app/setting/user-mgt/resource/ResourceForm"),
                                        props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    }
                                ]
                            },
                            {
                                path: "menus",
                                redirect: { name: "menus" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "menus",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuList"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: "create",
                                        name: "menus-create",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "menus-edit",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "menus-view",
                                        component: () => import("../views/app/setting/user-mgt/menu/MenuForm"),
                                        props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: "menu-sides",
                        redirect: { name: "menu-sides" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "menu-sides",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "menu-sides-create",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "menu-sides-edit",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "menu-sides-view",
                                component: () => import("../views/app/setting/user-mgt/menu-side/MenuSideForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "application",
                        redirect: { name: "application" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "application",
                                component: () => import("../views/app/setting/application/Application")
                            }
                        ]
                    }
                ]
            },
            {
                path: "company",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "company",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "mgt",
                        redirect: { name: "company-mgt" },
                        component: {
                            render: () => <router-view></router-view>,
                            setup() {
                                const route = useRoute();
                                const title = computed(() => {
                                    if (route.name === "company-mgt") {
                                        return undefined;
                                    }
                                    const routes = createRoutedMap(route.matched, stateAppLayout.menuSides);
                                    return routes.find(d => d.url === "/app/company/mgt")?.name;
                                });
                                return { title };
                            }
                        },
                        children: [
                            {
                                path: "",
                                name: "company-mgt",
                                component: () => import("../views/app/company/mgt/Mgt")
                            },
                            {
                                path: "tab",
                                component: RouteView,
                                meta: { noRemove: true },
                                children: [
                                    {
                                        path: "",
                                        name: "company-mgt-tab",
                                        component: () => import("../views/app/company/mgt-tab/MgtTab"),
                                        meta: { noHistory: true },
                                        children: [
                                            {
                                                path: ":companyId/:personType/1",
                                                component: {
                                                    render: () => <router-view></router-view>,
                                                    setup() {
                                                        const route = useRoute();
                                                        const title = computed(() =>
                                                            i18n.global.t(`views.company.mgt.tab.1.${route.params.personType}`)
                                                        );
                                                        return { title };
                                                    }
                                                },
                                                children: [
                                                    {
                                                        path: "",
                                                        name: "company-mgt-tab-1",
                                                        component: () => import("../views/app/company/mgt-tab/tab-1/Tab1Tab"),
                                                        children: [
                                                            {
                                                                path: "1",
                                                                name: "company-mgt-tab-1-1",
                                                                component: () => import("../views/app/company/mgt-tab/tab-1/Tab1List"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/create",
                                                                name: "company-mgt-tab-1-1-create",
                                                                component: () => import("../views/app/company/mgt-tab/tab-1/Tab1Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/edit",
                                                                name: "company-mgt-tab-1-1-edit",
                                                                component: () => import("../views/app/company/mgt-tab/tab-1/Tab1Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/view",
                                                                name: "company-mgt-tab-1-1-view",
                                                                component: () => import("../views/app/company/mgt-tab/tab-1/Tab1Form"),
                                                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2",
                                                                name: "company-mgt-tab-1-2",
                                                                component: () => import("../views/app/company/mgt-tab/tab-1/Tab1Data"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                path: ":companyId/:personType/2",
                                                component: {
                                                    render: () => <router-view></router-view>,
                                                    setup() {
                                                        const title = computed(() => i18n.global.t(`views.company.mgt.tab.2.title`));
                                                        return { title };
                                                    }
                                                },
                                                children: [
                                                    {
                                                        path: "",
                                                        name: "company-mgt-tab-2",
                                                        component: () => import("../views/app/company/mgt-tab/tab-2/Tab2Tab"),
                                                        children: [
                                                            {
                                                                path: "1",
                                                                name: "company-mgt-tab-2-1",
                                                                component: () => import("../views/app/company/mgt-tab/tab-2/Tab2List"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/create",
                                                                name: "company-mgt-tab-2-1-create",
                                                                component: () => import("../views/app/company/mgt-tab/tab-2/Tab2Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/edit",
                                                                name: "company-mgt-tab-2-1-edit",
                                                                component: () => import("../views/app/company/mgt-tab/tab-2/Tab2Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/view",
                                                                name: "company-mgt-tab-2-1-view",
                                                                component: () => import("../views/app/company/mgt-tab/tab-2/Tab2Form"),
                                                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2",
                                                                name: "company-mgt-tab-2-2",
                                                                component: () => import("../views/app/company/mgt-tab/tab-2/Tab2Data"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                path: ":companyId/:personType/3",
                                                component: {
                                                    render: () => <router-view></router-view>,
                                                    setup() {
                                                        const title = computed(() => i18n.global.t(`views.company.mgt.tab.3.title`));
                                                        return { title };
                                                    }
                                                },
                                                children: [
                                                    {
                                                        path: "",
                                                        name: "company-mgt-tab-3",
                                                        component: () => import("../views/app/company/mgt-tab/tab-3/Tab3Tab"),
                                                        children: [
                                                            {
                                                                path: "1",
                                                                name: "company-mgt-tab-3-1",
                                                                component: () => import("../views/app/company/mgt-tab/tab-3/Tab3List"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/create",
                                                                name: "company-mgt-tab-3-1-create",
                                                                component: () => import("../views/app/company/mgt-tab/tab-3/Tab3Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/edit",
                                                                name: "company-mgt-tab-3-1-edit",
                                                                component: () => import("../views/app/company/mgt-tab/tab-3/Tab3Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/view",
                                                                name: "company-mgt-tab-3-1-view",
                                                                component: () => import("../views/app/company/mgt-tab/tab-3/Tab3Form"),
                                                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2",
                                                                name: "company-mgt-tab-3-2",
                                                                component: () => import("../views/app/company/mgt-tab/tab-3/Tab3DataList"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/create",
                                                                name: "company-mgt-tab-3-2-create",
                                                                component: () => import("../views/app/company/mgt-tab/tab-3/Tab3DataForm"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/:id/edit",
                                                                name: "company-mgt-tab-3-2-edit",
                                                                component: () => import("../views/app/company/mgt-tab/tab-3/Tab3DataForm"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/:id/view",
                                                                name: "company-mgt-tab-3-2-view",
                                                                component: () => import("../views/app/company/mgt-tab/tab-3/Tab3DataForm"),
                                                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                path: ":companyId/:personType/4",
                                                component: {
                                                    render: () => <router-view></router-view>,
                                                    setup() {
                                                        const title = computed(() => i18n.global.t(`views.company.mgt.tab.4.title`));
                                                        return { title };
                                                    }
                                                },
                                                children: [
                                                    {
                                                        path: "",
                                                        name: "company-mgt-tab-4",
                                                        component: () => import("../views/app/company/mgt-tab/tab-4/Tab4Tab"),
                                                        children: [
                                                            {
                                                                path: "1",
                                                                name: "company-mgt-tab-4-1",
                                                                component: () => import("../views/app/company/mgt-tab/tab-4/Tab4List"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/create",
                                                                name: "company-mgt-tab-4-1-create",
                                                                component: () => import("../views/app/company/mgt-tab/tab-4/Tab4Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/edit",
                                                                name: "company-mgt-tab-4-1-edit",
                                                                component: () => import("../views/app/company/mgt-tab/tab-4/Tab4Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/view",
                                                                name: "company-mgt-tab-4-1-view",
                                                                component: () => import("../views/app/company/mgt-tab/tab-4/Tab4Form"),
                                                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2",
                                                                name: "company-mgt-tab-4-2",
                                                                component: () => import("../views/app/company/mgt-tab/tab-4/Tab4DataList"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/create",
                                                                name: "company-mgt-tab-4-2-create",
                                                                component: () => import("../views/app/company/mgt-tab/tab-4/Tab4DataForm"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/:id/edit",
                                                                name: "company-mgt-tab-4-2-edit",
                                                                component: () => import("../views/app/company/mgt-tab/tab-4/Tab4DataForm"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/:id/view",
                                                                name: "company-mgt-tab-4-2-view",
                                                                component: () => import("../views/app/company/mgt-tab/tab-4/Tab4DataForm"),
                                                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                path: ":companyId/:personType/5",
                                                component: {
                                                    render: () => <router-view></router-view>,
                                                    setup() {
                                                        const title = computed(() => i18n.global.t(`views.company.mgt.tab.5.title`));
                                                        return { title };
                                                    }
                                                },
                                                children: [
                                                    {
                                                        path: "",
                                                        name: "company-mgt-tab-5",
                                                        component: () => import("../views/app/company/mgt-tab/tab-5/Tab5Tab"),
                                                        children: [
                                                            {
                                                                path: "1",
                                                                name: "company-mgt-tab-5-1",
                                                                component: () => import("../views/app/company/mgt-tab/tab-5/Tab5List"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/create",
                                                                name: "company-mgt-tab-5-1-create",
                                                                component: () => import("../views/app/company/mgt-tab/tab-5/Tab5Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/edit",
                                                                name: "company-mgt-tab-5-1-edit",
                                                                component: () => import("../views/app/company/mgt-tab/tab-5/Tab5Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/view",
                                                                name: "company-mgt-tab-5-1-view",
                                                                component: () => import("../views/app/company/mgt-tab/tab-5/Tab5Form"),
                                                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2",
                                                                name: "company-mgt-tab-5-2",
                                                                component: () => import("../views/app/company/mgt-tab/tab-5/Tab5DataList"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/create",
                                                                name: "company-mgt-tab-5-2-create",
                                                                component: () => import("../views/app/company/mgt-tab/tab-5/Tab5DataForm"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/:id/edit",
                                                                name: "company-mgt-tab-5-2-edit",
                                                                component: () => import("../views/app/company/mgt-tab/tab-5/Tab5DataForm"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/:id/view",
                                                                name: "company-mgt-tab-5-2-view",
                                                                component: () => import("../views/app/company/mgt-tab/tab-5/Tab5DataForm"),
                                                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                path: ":companyId/:personType/6",
                                                component: {
                                                    render: () => <router-view></router-view>,
                                                    setup() {
                                                        const title = computed(() => i18n.global.t(`views.company.mgt.tab.6.title`));
                                                        return { title };
                                                    }
                                                },
                                                children: [
                                                    {
                                                        path: "",
                                                        name: "company-mgt-tab-6",
                                                        component: () => import("../views/app/company/mgt-tab/tab-6/Tab6Tab"),
                                                        children: [
                                                            {
                                                                path: "1",
                                                                name: "company-mgt-tab-6-1",
                                                                component: () => import("../views/app/company/mgt-tab/tab-6/Tab6List"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/create",
                                                                name: "company-mgt-tab-6-1-create",
                                                                component: () => import("../views/app/company/mgt-tab/tab-6/Tab6Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/edit",
                                                                name: "company-mgt-tab-6-1-edit",
                                                                component: () => import("../views/app/company/mgt-tab/tab-6/Tab6Form"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "1/:id/view",
                                                                name: "company-mgt-tab-6-1-view",
                                                                component: () => import("../views/app/company/mgt-tab/tab-6/Tab6Form"),
                                                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2",
                                                                name: "company-mgt-tab-6-2",
                                                                component: () => import("../views/app/company/mgt-tab/tab-6/Tab6DataList"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/create",
                                                                name: "company-mgt-tab-6-2-create",
                                                                component: () => import("../views/app/company/mgt-tab/tab-6/Tab6DataForm"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/:id/edit",
                                                                name: "company-mgt-tab-6-2-edit",
                                                                component: () => import("../views/app/company/mgt-tab/tab-6/Tab6DataForm"),
                                                                props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            },
                                                            {
                                                                path: "2/:id/view",
                                                                name: "company-mgt-tab-6-2-view",
                                                                component: () => import("../views/app/company/mgt-tab/tab-6/Tab6DataForm"),
                                                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) }),
                                                                meta: { noHistory: false }
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                path: ":companyId/:personType/7",
                                                component: {
                                                    render: () => <router-view></router-view>,
                                                    setup() {
                                                        const title = computed(() => i18n.global.t(`views.company.mgt.tab.7.title`));
                                                        return { title };
                                                    }
                                                },
                                                children: [
                                                    {
                                                        path: "",
                                                        name: "company-mgt-tab-7",
                                                        component: () => import("../views/app/company/mgt-tab/tab-7/Tab7Form"),
                                                        props: route => ({ ...JSON.parse(route.params?.props || null) }),
                                                        meta: { noHistory: false }
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: "role-mgt",
                        redirect: { name: "company-role-mgt" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "company-role-mgt",
                                component: () => import("../views/app/company/role-mgt/RoleMgtList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "company-role-mgt-edit",
                                component: () => import("../views/app/company/role-mgt/RoleMgtForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "company-role-mgt-view",
                                component: () => import("../views/app/company/role-mgt/RoleMgtForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    }
                ]
            },
            {
                path: "officer",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "officer",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "users",
                        redirect: { name: "officer-users" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "officer-users",
                                component: () => import("../views/app/officer/user/UserList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    }
                ]
            },
            {
                path: "officer-approves",
                redirect: { name: "officer-approves" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "officer-approves",
                        component: () => import("../views/app/officer-approve/OfficerApproveList"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: ":id/edit",
                        name: "officer-approves-edit",
                        component: () => import("../views/app/officer-approve/OfficerApproveForm"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                    },
                    {
                        path: ":id/view",
                        name: "officer-approves-view",
                        component: () => import("../views/app/officer-approve/OfficerApproveForm"),
                        props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                    }
                ]
            },
            {
                path: "master-mgt",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "master-mgt",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "haz-sub-stances",
                        redirect: { name: "haz-sub-stances" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-sub-stances",
                                component: () => import("../views/app/master-mgt/haz-sub-stance/HazSubStanceList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "haz-sub-stances-create",
                                component: () => import("../views/app/master-mgt/haz-sub-stance/HazSubStanceForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-sub-stances-edit",
                                component: () => import("../views/app/master-mgt/haz-sub-stance/HazSubStanceForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "haz-sub-stances-view",
                                component: () => import("../views/app/master-mgt/haz-sub-stance/HazSubStanceForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "coordinate-customses",
                        redirect: { name: "coordinate-customses" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "coordinate-customses",
                                component: () => import("../views/app/master-mgt/coordinate-customs/CoordinateCustomsList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "coordinate-customses-create",
                                component: () => import("../views/app/master-mgt/coordinate-customs/CoordinateCustomsForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "coordinate-customses-edit",
                                component: () => import("../views/app/master-mgt/coordinate-customs/CoordinateCustomsForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "coordinate-customses-view",
                                component: () => import("../views/app/master-mgt/coordinate-customs/CoordinateCustomsForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "haz-objects",
                        redirect: { name: "haz-objects" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-objects",
                                component: () => import("../views/app/master-mgt/haz-object/HazObjectList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "haz-objects-create",
                                component: () => import("../views/app/master-mgt/haz-object/HazObjectForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-objects-edit",
                                component: () => import("../views/app/master-mgt/haz-object/HazObjectForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "haz-objects-view",
                                component: () => import("../views/app/master-mgt/haz-object/HazObjectForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "ld50",
                        redirect: { name: "ld50" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "ld50",
                                component: () => import("../views/app/master-mgt/ld50/Ld50List"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "ld50-create",
                                component: () => import("../views/app/master-mgt/ld50/Ld50Form"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "ld50-edit",
                                component: () => import("../views/app/master-mgt/ld50/Ld50Form"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "ld50-view",
                                component: () => import("../views/app/master-mgt/ld50/Ld50Form"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "pictogram",
                        redirect: { name: "pictogram" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "pictogram",
                                component: () => import("../views/app/master-mgt/pictogram/PictogramList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "pictogram-create",
                                component: () => import("../views/app/master-mgt/pictogram/PictogramForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "pictogram-edit",
                                component: () => import("../views/app/master-mgt/pictogram/PictogramForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "pictogram-view",
                                component: () => import("../views/app/master-mgt/pictogram/PictogramForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "haz-discuss-cases",
                        redirect: { name: "haz-discuss-case" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-discuss-cases",
                                component: () => import("../views/app/master-mgt/haz-discuss-case/HazDiscussCaseList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "haz-discuss-cases-create",
                                component: () => import("../views/app/master-mgt/haz-discuss-case/HazDiscussCaseForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-discuss-cases-edit",
                                component: () => import("../views/app/master-mgt/haz-discuss-case/HazDiscussCaseForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "haz-discuss-cases-view",
                                component: () => import("../views/app/master-mgt/haz-discuss-case/HazDiscussCaseForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "inspection-risks",
                        redirect: { name: "inspection-risks" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "inspection-risks",
                                component: () => import("../views/app/master-mgt/inspection-risk/InspectionRiskList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "inspection-risks-create",
                                component: () => import("../views/app/master-mgt/inspection-risk/InspectionRiskForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "inspection-risks-edit",
                                component: () => import("../views/app/master-mgt/inspection-risk/InspectionRiskForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "inspection-risks-view",
                                component: () => import("../views/app/master-mgt/inspection-risk/InspectionRiskForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "user-red-accounts",
                        redirect: { name: "user-red-accounts" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "user-red-accounts",
                                component: () => import("../views/app/master-mgt/user-red-account/UserRedAccountList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "user-red-accounts-create",
                                component: () => import("../views/app/master-mgt/user-red-account/UserRedAccountForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "user-red-accounts-edit",
                                component: () => import("../views/app/master-mgt/user-red-account/UserRedAccountForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "user-red-accounts-view",
                                component: () => import("../views/app/master-mgt/user-red-account/UserRedAccountForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                    {
                        path: "risk-topics",
                        redirect: { name: "risk-topics" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "risk-topics",
                                component: () => import("../views/app/master-mgt/risk-topic/RiskTopicList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "risk-topics-create",
                                component: () => import("../views/app/master-mgt/risk-topic/RiskTopicForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "risk-topics-edit",
                                component: () => import("../views/app/master-mgt/risk-topic/RiskTopicForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "risk-topics-view",
                                component: () => import("../views/app/master-mgt/risk-topic/RiskTopicForm"),
                                props: { viewOnly: true }
                            }
                        ]
                    },
                ]
            },
            {
                path: "fee",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "fee-setup",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "setting-mgt",
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "setting-mgt",
                                component: () => import("../views/menu-list/MenuList"),
                                meta: { isAuth: true }
                            },
                            {
                                path: "fee-rates",
                                redirect: { name: "fee-rates" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "fee-rates",
                                        component: () => import("../views/app/fee/setting-mgt/fee-rate/FeeRateList"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: "create",
                                        name: "fee-rates-create",
                                        component: () => import("../views/app/fee/setting-mgt/fee-rate/FeeRateForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "fee-rates-edit",
                                        component: () => import("../views/app/fee/setting-mgt/fee-rate/FeeRateForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "fee-rates-view",
                                        component: () => import("../views/app/fee/setting-mgt/fee-rate/FeeRateForm"),
                                        props: { viewOnly: true }
                                    }
                                ]
                            }
                            /*
                            {
                                path: "fee-waivers",
                                redirect: { name: "fee-waivers" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "fee-waivers",
                                        component: () => import("../views/app/fee/setting-mgt/fee-waiver/FeeWaiverList"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: "create",
                                        name: "fee-waivers-create",
                                        component: () => import("../views/app/fee/setting-mgt/fee-waiver/FeeWaiverForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "fee-waivers-edit",
                                        component: () => import("../views/app/fee/setting-mgt/fee-waiver/FeeWaiverForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "fee-waivers-view",
                                        component: () => import("../views/app/fee/setting-mgt/fee-waiver/FeeWaiverForm"),
                                        props: { viewOnly: true }
                                    }
                                ]
                            },
                            */
                        ]
                    }
                ]
            },
            {
                path: "haz",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "haz",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "hazes",
                        redirect: { name: "hazes" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "hazes",
                                component: () => import("../views/app/haz/haz/HazList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "hazes-create",
                                component: () => import("../views/app/haz/haz/HazForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "hazes-edit",
                                component: () => import("../views/app/haz/haz/HazForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "hazes-view",
                                component: () => import("../views/app/haz/haz/HazForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "haz-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-requests",
                                component: () => import("../views/app/haz/request/RequestList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "haz-requests-create",
                                component: () => import("../views/app/haz/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-requests-edit",
                                component: () => import("../views/app/haz/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "haz-requests-view",
                                component: () => import("../views/app/haz/request/RequestForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "haz-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-request-receives",
                                component: () => import("../views/app/haz/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "haz-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-request-receives-create",
                                component: () => import("../views/app/haz/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-request-receives-edit",
                                component: () => import("../views/app/haz/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-request-receives-view",
                                component: () => import("../views/app/haz/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "haz-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-request-approves",
                                component: () => import("../views/app/haz/request/RequestApproveList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "haz-request-approves-create",
                                component: () => import("../views/app/haz/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-request-approves-edit",
                                component: () => import("../views/app/haz/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-request-approves-view",
                                component: () => import("../views/app/haz/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "haz-license",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "haz-license",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "haz-licenses",
                        redirect: { name: "haz-licenses" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-licenses",
                                component: () => import("../views/app/haz-license/haz-license/HazLicenseList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "haz-licenses-create",
                                component: () => import("../views/app/haz-license/haz-license/HazLicenseForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-licenses-edit",
                                component: () => import("../views/app/haz-license/haz-license/HazLicenseForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "haz-licenses-view",
                                component: () => import("../views/app/haz-license/haz-license/HazLicenseForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "haz-license-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-license-requests",
                                component: () => import("../views/app/haz-license/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "haz-license-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-license-requests-create",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-license-requests-edit",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-license-requests-view",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-requests",
                                    viewOnly: true,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "haz-license-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-license-request-receives",
                                component: () => import("../views/app/haz-license/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "haz-license-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-license-request-receives-create",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-license-request-receives-edit",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-license-request-receives-view",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-license-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "haz-license-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-license-request-approves",
                                component: () => import("../views/app/haz-license/request/RequestApproveList"),
                                props: route => ({
                                    routerPrefix: "haz-license-notice-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-license-request-approves-create",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-license-request-approves-edit",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-license-request-approves-view",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-license-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "haz-license-notice",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "haz-license-notice",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "haz-licenses",
                        redirect: { name: "haz-license-notices" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-license-notices",
                                component: () => import("../views/app/haz-license/haz-license/HazLicenseList"),
                                props: route => ({
                                    routerPrefix: "haz-license-notices",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-license-notices-create",
                                component: () => import("../views/app/haz-license/haz-license/HazLicenseForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-notices-create",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-license-notices-edit",
                                component: () => import("../views/app/haz-license/haz-license/HazLicenseForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-notices-edit",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-license-notices-view",
                                component: () => import("../views/app/haz-license/haz-license/HazLicenseForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-notices-view",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "haz-license-notice-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-license-notice-requests",
                                component: () => import("../views/app/haz-license/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "haz-license-notice-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-license-notice-requests-create",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-notice-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-license-notice-requests-edit",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-notice-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-license-notice-requests-view",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-notice-requests",
                                    viewOnly: true,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "haz-license-notice-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-license-notice-request-receives",
                                component: () => import("../views/app/haz-license/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "haz-license-notice-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-license-notice-request-receives-create",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-notice-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-license-notice-request-receives-edit",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-notice-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-license-notice-request-receives-view",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-license-notice-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "haz-license-notice-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-license-notice-request-approves",
                                component: () => import("../views/app/haz-license/request/RequestApproveList"),
                                props: route => ({
                                    routerPrefix: "haz-license-notice-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-license-notice-request-approves-create",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-notice-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-license-notice-request-approves-edit",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-license-notice-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-license-notice-request-approves-view",
                                component: () => import("../views/app/haz-license/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-license-notice-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "haz-license-details",
                redirect: { name: "haz-license-details" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "haz-license-details",
                        component: () => import("../views/app/haz-license/request/haz-license-detail/HazLicenseDetailTable")
                    }
                ]
            },
            {
                path: "haz-license-storage-locations",
                redirect: { name: "haz-license-storage-locations" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "haz-license-storage-locations",
                        component: () => import("../views/app/haz-license/request/haz-license-storage-location/HazLicenseStorageLocationTable"),
                        props: route => ({
                            isLocation: true,
                            ...JSON.parse(route.params?.props || null)
                        })
                    }
                ]
            },
            {
                path: "haz-license-manufacture-locations",
                redirect: { name: "haz-license-manufacture-locations" },
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "haz-license-manufacture-locations",
                        component: () => import("../views/app/haz-license/request/haz-license-storage-location/HazLicenseStorageLocationTable"),
                        props: route => ({
                            isLocation: false,
                            ...JSON.parse(route.params?.props || null)
                        })
                    }
                ]
            },
            {
                path: "storage-location",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "storage-location",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "storage-locations",
                        redirect: { name: "storage-locations" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "storage-locations",
                                component: () => import("../views/app/storage-location/storage-location/StorageLocationList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "storage-locations-create",
                                component: () => import("../views/app/storage-location/storage-location/StorageLocationForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "storage-locations-edit",
                                component: () => import("../views/app/storage-location/storage-location/StorageLocationForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "storage-locations-view",
                                component: () => import("../views/app/storage-location/storage-location/StorageLocationForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "storage-location-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "storage-location-requests",
                                component: () => import("../views/app/storage-location/request/RequestList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "storage-location-requests-create",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "storage-location-requests-edit",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "storage-location-requests-view",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "storage-location-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "storage-location-request-receives",
                                component: () => import("../views/app/storage-location/request/RequestList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "storage-location-request-receives-create",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "storage-location-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "storage-location-request-receives-edit",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "storage-location-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "storage-location-request-receives-view",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "storage-location-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "storage-location-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "storage-location-request-approves",
                                component: () => import("../views/app/storage-location/request/RequestApproveList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "storage-location-request-approves-create",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "storage-location-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "storage-location-request-approves-edit",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "storage-location-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "storage-location-request-approves-view",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "storage-location-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "manufacture-location",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "manufacture-location",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "manufacture-locations",
                        redirect: { name: "manufacture-locations" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "manufacture-locations",
                                component: () => import("../views/app/storage-location/storage-location/StorageLocationList"),
                                props: route => ({
                                    routerPrefix: "manufacture-locations",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "manufacture-locations-create",
                                component: () => import("../views/app/storage-location/storage-location/StorageLocationForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-locations",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "manufacture-locations-edit",
                                component: () => import("../views/app/storage-location/storage-location/StorageLocationForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-locations",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "manufacture-locations-view",
                                component: () => import("../views/app/storage-location/storage-location/StorageLocationForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "manufacture-locations",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "manufacture-location-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "manufacture-location-requests",
                                component: () => import("../views/app/storage-location/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "manufacture-location-requests",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "manufacture-location-requests-create",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-location-requests",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "manufacture-location-requests-edit",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-location-requests",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "manufacture-location-requests-view",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "manufacture-location-requests",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "manufacture-location-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "manufacture-location-request-receives",
                                component: () => import("../views/app/storage-location/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "manufacture-location-request-receives",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "manufacture-location-request-receives-create",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-location-request-receives",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "manufacture-location-request-receives-edit",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-location-request-receives",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "manufacture-location-request-receives-view",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "manufacture-location-request-receives",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "manufacture-location-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "manufacture-location-request-approves",
                                component: () => import("../views/app/storage-location/request/RequestApproveList"),
                                props: route => ({
                                    routerPrefix: "manufacture-location-request-receives",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "manufacture-location-request-approves-create",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-location-request-approves",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "manufacture-location-request-approves-edit",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-location-request-approves",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "manufacture-location-request-approves-view",
                                component: () => import("../views/app/storage-location/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "manufacture-location-request-approves",
                                    isLocation: false,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "inform",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "inform",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "informs",
                        redirect: { name: "informs" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "informs",
                                component: () => import("../views/app/inform/inform/informList"),
                                props: route => ({
                                    routerPrefix: "informs",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "informs-view",
                                component: () => import("../views/app/inform/inform/informForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "informs",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "inform-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "inform-requests",
                                component: () => import("../views/app/inform/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "inform-requests",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "inform-requests-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "inform-requests",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "inform-requests-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "inform-requests",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "inform-requests-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "inform-requests",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "inform-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "inform-request-receives",
                                component: () => import("../views/app/inform/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "inform-request-receives",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "inform-request-receives-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "inform-request-receives",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "inform-request-receives-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "inform-request-receives",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "inform-request-receives-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "inform-request-receives",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "inform-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "inform-request-approves",
                                component: () => import("../views/app/inform/request/RequestApproveList"),
                                props: route => ({
                                    routerPrefix: "inform-request-approves",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "inform-request-approves-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "inform-request-approves",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "inform-request-approves-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "inform-request-approves",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "inform-request-approves-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "inform-request-approves",
                                    requestDocKeys: ["16", "17"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "import-sample",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "import-sample",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "import-samples",
                        redirect: { name: "import-samples" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "import-samples",
                                component: () => import("../views/app/inform/inform/informList"),
                                props: route => ({
                                    routerPrefix: "import-samples",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "import-samples-view",
                                component: () => import("../views/app/inform/inform/informForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "import-samples",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "import-sample-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "import-sample-requests",
                                component: () => import("../views/app/inform/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "import-sample-requests",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "import-sample-requests-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "import-sample-requests",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "import-sample-requests-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "import-sample-requests",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "import-sample-requests-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "import-sample-requests",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "import-sample-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "import-sample-request-receives",
                                component: () => import("../views/app/inform/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "import-sample-request-receives",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "import-sample-request-receives-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "import-sample-request-receives",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "import-sample-request-receives-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "import-sample-request-receives",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "import-sample-request-receives-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "import-sample-request-receives",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "import-sample-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "import-sample-request-approves",
                                component: () => import("../views/app/inform/request/RequestApproveList"),
                                props: route => ({
                                    requestDocKeys: ["02"],
                                    routerPrefix: "import-sample-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "import-sample-request-approves-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "import-sample-request-approves",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "import-sample-request-approves-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "import-sample-request-approves",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "import-sample-request-approves-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "import-sample-request-approves",
                                    requestDocKeys: ["02"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "pass",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "pass",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "passes",
                        redirect: { name: "passes" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "passes",
                                component: () => import("../views/app/inform/inform/informList"),
                                props: route => ({
                                    routerPrefix: "passes",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "passes-view",
                                component: () => import("../views/app/inform/inform/informForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "passes",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "pass-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "pass-requests",
                                component: () => import("../views/app/inform/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "pass-requests",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "pass-requests-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass-requests",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "pass-requests-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass-requests",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "pass-requests-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "pass-requests",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "pass-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "pass-request-receives",
                                component: () => import("../views/app/inform/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "pass-request-receives",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "pass-request-receives-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass-request-receives",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "pass-request-receives-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass-request-receives",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "pass-request-receives-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "pass-request-receives",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "pass-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "pass-request-approves",
                                component: () => import("../views/app/inform/request/RequestApproveList"),
                                props: route => ({
                                    requestDocKeys: ["18"],
                                    routerPrefix: "pass-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "pass-request-approves-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass-request-approves",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "pass-request-approves-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass-request-approves",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "pass-request-approves-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "pass-request-approves",
                                    requestDocKeys: ["18"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "pass3",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "pass3",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "pass3es",
                        redirect: { name: "pass3es" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "pass3es",
                                component: () => import("../views/app/inform/inform/informList"),
                                props: route => ({
                                    routerPrefix: "pass3es",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "pass3es-view",
                                component: () => import("../views/app/inform/inform/informForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "pass3es",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "pass3-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "pass3-requests",
                                component: () => import("../views/app/inform/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "pass3-requests",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "pass3-requests-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass3-requests",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "pass3-requests-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass3-requests",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "pass3-requests-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "pass3-requests",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "pass3-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "pass3-request-receives",
                                component: () => import("../views/app/inform/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "pass3-request-receives",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "pass3-request-receives-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass3-request-receives",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "pass3-request-receives-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass3-request-receives",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "pass3-request-receives-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "pass3-request-receives",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "pass3-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "pass3-request-approves",
                                component: () => import("../views/app/inform/request/RequestApproveList"),
                                props: route => ({
                                    requestDocKeys: ["19"],
                                    routerPrefix: "pass3-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "pass3-request-approves-create",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass3-request-approves",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "pass3-request-approves-edit",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "pass3-request-approves",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "pass3-request-approves-view",
                                component: () => import("../views/app/inform/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "pass3-request-approves",
                                    requestDocKeys: ["19"],
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "inspection",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "inspection",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "inspections",
                        redirect: { name: "inspections" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "inspections",
                                component: () => import("../views/app/inspection/inspection/inspectionList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "inspections-view",
                                component: () => import("../views/app/inspection/inspection/inspectionForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "inspection-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "inspection-requests",
                                component: () => import("../views/app/inspection/request/RequestList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "inspection-requests-create",
                                component: () => import("../views/app/inspection/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "inspection-requests-edit",
                                component: () => import("../views/app/inspection/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "inspection-requests-view",
                                component: () => import("../views/app/inspection/request/RequestForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "inspection-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "inspection-request-receives",
                                component: () => import("../views/app/inspection/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "inspection-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "inspection-request-receives-create",
                                component: () => import("../views/app/inspection/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "inspection-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "inspection-request-receives-edit",
                                component: () => import("../views/app/inspection/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "inspection-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "inspection-request-receives-view",
                                component: () => import("../views/app/inspection/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "inspection-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "inspection-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "inspection-request-approves",
                                component: () => import("../views/app/inspection/request/RequestApproveList"),
                                props: route => ({
                                    routerPrefix: "inspection-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "inspection-request-approves-create",
                                component: () => import("../views/app/inspection/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "inspection-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "inspection-request-approves-edit",
                                component: () => import("../views/app/inspection/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "inspection-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "inspection-request-approves-view",
                                component: () => import("../views/app/inspection/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "inspection-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "release",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "release",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "releases",
                        redirect: { name: "releases" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "releases",
                                component: () => import("../views/app/release/release/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "releases",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "releases-view",
                                component: () => import("../views/app/release/release/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "releases",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request",
                        redirect: { name: "release-request" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "release-request",
                                component: () => import("../views/menu-list/MenuList"),
                                meta: { isAuth: true }
                            },
                            {
                                path: "results",
                                redirect: { name: "release-results" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "release-results",
                                        component: () => import("../views/app/release/release/request/RequestList"),
                                        props: route => ({
                                            routerPrefix: "release-results",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: "create",
                                        name: "release-results-create",
                                        component: () => import("../views/app/release/release/request/RequestForm"),
                                        props: route => ({
                                            routerPrefix: "release-results",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "release-results-edit",
                                        component: () => import("../views/app/release/release/request/RequestForm"),
                                        props: route => ({
                                            routerPrefix: "release-results",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "release-results-view",
                                        component: () => import("../views/app/release/release/request/RequestForm"),
                                        props: route => ({
                                            viewOnly: true,
                                            routerPrefix: "release-results",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "requests",
                                redirect: { name: "release-requests" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "release-requests",
                                        component: () => import("../views/app/release/release/request/RequestList"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: "create",
                                        name: "release-requests-create",
                                        component: () => import("../views/app/release/release/request/RequestForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "release-requests-edit",
                                        component: () => import("../views/app/release/release/request/RequestForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "release-requests-view",
                                        component: () => import("../views/app/release/release/request/RequestForm"),
                                        props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    }
                                ]
                            },
                            {
                                path: "send-samplings",
                                redirect: { name: "send-samplings" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "send-samplings",
                                        component: () => import("../views/app/release/send-sampling/request/RequestList"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: "create",
                                        name: "send-samplings-create",
                                        component: () => import("../views/app/release/send-sampling/request/RequestForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "send-samplings-edit",
                                        component: () => import("../views/app/release/send-sampling/request/RequestForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "send-samplings-view",
                                        component: () => import("../views/app/release/send-sampling/request/RequestForm"),
                                        props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    }
                                ]
                            },
                            {
                                path: "analysiss",
                                redirect: { name: "sampling-analysiss" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "sampling-analysiss",
                                        component: () => import("../views/app/release/sampling-analysis/request/SamplingAnalysisList"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: "create",
                                        name: "sampling-analysiss-create",
                                        component: () => import("../views/app/release/sampling-analysis/request/SamplingAnalysisForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "sampling-analysiss-edit",
                                        component: () => import("../views/app/release/sampling-analysis/request/SamplingAnalysisForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "sampling-analysiss-view",
                                        component: () => import("../views/app/release/sampling-analysis/request/SamplingAnalysisForm"),
                                        props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    }
                                ]
                            },
                            {
                                path: "cancel-sequestrates",
                                redirect: { name: "cancel-sequestrates" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "cancel-sequestrates",
                                        component: () => import("../views/app/release/cancel-sequestrate/request/CancelSequestrateList"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: "create",
                                        name: "cancel-sequestrates-create",
                                        component: () => import("../views/app/release/cancel-sequestrate/request/CancelSequestrateForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "cancel-sequestrates-edit",
                                        component: () => import("../views/app/release/cancel-sequestrate/request/CancelSequestrateForm"),
                                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "cancel-sequestrates-view",
                                        component: () => import("../views/app/release/cancel-sequestrate/request/CancelSequestrateForm"),
                                        props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                                    }
                                ]
                            },
                            {
                                path: "follow-releases",
                                redirect: { name: "follow-releases" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "follow-releases",
                                        component: () => import("../views/app/release/cancel-sequestrate/cancel-sequestrate/CancelSequestrateList"),
                                        props: route => ({
                                            routerPrefix: "follow-releases",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: "create",
                                        name: "follow-releases-create",
                                        component: () => import("../views/app/release/cancel-sequestrate/cancel-sequestrate/CancelSequestrateForm"),
                                        props: route => ({
                                            routerPrefix: "follow-releases",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "follow-releases-edit",
                                        component: () => import("../views/app/release/cancel-sequestrate/cancel-sequestrate/CancelSequestrateForm"),
                                        props: route => ({
                                            routerPrefix: "follow-releases",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "follow-releases-view",
                                        component: () => import("../views/app/release/cancel-sequestrate/cancel-sequestrate/CancelSequestrateForm"),
                                        props: route => ({
                                            viewOnly: true,
                                            routerPrefix: "follow-releases",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: "change",
                        redirect: { name: "sequestrate-change" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "sequestrate-change",
                                component: () => import("../views/menu-list/MenuList"),
                                meta: { isAuth: true }
                            },
                            {
                                path: "open-inspections",
                                redirect: { name: "open-inspection-changes" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "open-inspection-changes",
                                        component: () => import("../views/app/release/open-inspection/request/RequestList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: "create",
                                        name: "open-inspection-changes-create",
                                        component: () => import("../views/app/release/open-inspection/request/RequestForm"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "open-inspection-changes-edit",
                                        component: () => import("../views/app/release/open-inspection/request/RequestForm"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "open-inspection-changes-view",
                                        component: () => import("../views/app/release/open-inspection/request/RequestForm"),
                                        props: route => ({
                                            viewOnly: true,
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "samplings",
                                redirect: { name: "sampling-changes" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "sampling-changes",
                                        component: () => import("../views/app/release/sampling/request/RequestList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: "create",
                                        name: "sampling-changes-create",
                                        component: () => import("../views/app/release/sampling/request/RequestForm"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "sampling-changes-edit",
                                        component: () => import("../views/app/release/sampling/request/RequestForm"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "sampling-changes-view",
                                        component: () => import("../views/app/release/sampling/request/RequestForm"),
                                        props: route => ({
                                            viewOnly: true,
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "sequestrates",
                                redirect: { name: "sequestrate-changes" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "sequestrate-changes",
                                        component: () => import("../views/app/release/sequestrate/request/RequestList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: "create",
                                        name: "sequestrate-changes-create",
                                        component: () => import("../views/app/release/sequestrate/request/RequestForm"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "sequestrate-changes-edit",
                                        component: () => import("../views/app/release/sequestrate/request/RequestForm"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "sequestrate-changes-view",
                                        component: () => import("../views/app/release/sequestrate/request/RequestForm"),
                                        props: route => ({
                                            viewOnly: true,
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: "cancel",
                        redirect: { name: "release-cancel" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "release-cancel",
                                component: () => import("../views/menu-list/MenuList"),
                                meta: { isAuth: true }
                            },
                            {
                                path: "requests",
                                redirect: { name: "release-cancels" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "release-cancels",
                                        component: () => import("../views/app/release/release/request/RequestList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "release-cancels",
                                            requestTypeKeys: ["4"]
                                        })
                                    },
                                    {
                                        path: "create",
                                        name: "release-cancels-create",
                                        component: () => import("../views/app/release/release/request/RequestForm"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "release-cancels",
                                            requestTypeKeys: ["4"]
                                        })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "release-cancels-edit",
                                        component: () => import("../views/app/release/release/request/RequestForm"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "release-cancels",
                                            requestTypeKeys: ["4"]
                                        })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "release-cancels-view",
                                        component: () => import("../views/app/release/release/request/RequestForm"),
                                        props: route => ({
                                            viewOnly: true,
                                            ...JSON.parse(route.params?.props || null),
                                            routerPrefix: "release-cancels",
                                            requestTypeKeys: ["4"]
                                        })
                                    }
                                ]
                            },
                            {
                                path: "send-samplings",
                                redirect: { name: "send-sampling-cancels" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "send-sampling-cancels",
                                        component: () => import("../views/app/release/send-sampling/request/RequestList"),
                                        props: route => ({
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "send-sampling-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: "create",
                                        name: "send-sampling-cancels-create",
                                        component: () => import("../views/app/release/send-sampling/request/RequestForm"),
                                        props: route => ({
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "send-sampling-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "send-sampling-cancels-edit",
                                        component: () => import("../views/app/release/send-sampling/request/RequestForm"),
                                        props: route => ({
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "send-sampling-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "send-sampling-cancels-view",
                                        component: () => import("../views/app/release/send-sampling/request/RequestForm"),
                                        props: route => ({
                                            viewOnly: true,
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "send-sampling-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "analysiss",
                                redirect: { name: "sampling-analysis-cancels" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "sampling-analysis-cancels",
                                        component: () => import("../views/app/release/sampling-analysis/request/SamplingAnalysisList"),
                                        props: route => ({
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "sampling-analysis-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: "create",
                                        name: "sampling-analysis-cancels-create",
                                        component: () => import("../views/app/release/sampling-analysis/request/SamplingAnalysisForm"),
                                        props: route => ({
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "sampling-analysis-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "sampling-analysis-cancels-edit",
                                        component: () => import("../views/app/release/sampling-analysis/request/SamplingAnalysisForm"),
                                        props: route => ({
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "sampling-analysis-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "sampling-analysis-cancels-view",
                                        component: () => import("../views/app/release/sampling-analysis/request/SamplingAnalysisForm"),
                                        props: route => ({
                                            viewOnly: true,
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "sampling-analysis-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "cancel-sequestrates",
                                redirect: { name: "cancel-sequestrate-cancels" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "cancel-sequestrate-cancels",
                                        component: () => import("../views/app/release/cancel-sequestrate/request/CancelSequestrateList"),
                                        props: route => ({
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "cancel-sequestrate-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: "create",
                                        name: "cancel-sequestrate-cancels-create",
                                        component: () => import("../views/app/release/cancel-sequestrate/request/CancelSequestrateForm"),
                                        props: route => ({
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "cancel-sequestrate-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/edit",
                                        name: "cancel-sequestrate-cancels-edit",
                                        component: () => import("../views/app/release/cancel-sequestrate/request/CancelSequestrateForm"),
                                        props: route => ({
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "cancel-sequestrate-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    },
                                    {
                                        path: ":id/view",
                                        name: "cancel-sequestrate-cancels-view",
                                        component: () => import("../views/app/release/cancel-sequestrate/request/CancelSequestrateForm"),
                                        props: route => ({
                                            viewOnly: true,
                                            requestTypeKeys: ["4"],
                                            routerPrefix: "cancel-sequestrate-cancels",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        path: "document",
                        redirect: { name: "release-document" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "release-document",
                                component: () => import("../views/menu-list/MenuList"),
                                meta: { isAuth: true }
                            },
                            {
                                path: "open-inspections",
                                name: "open-inspection-documents",
                                component: () => import("../views/app/release/open-inspection/open-inspection/OpenInspectionList"),
                                props: route => ({
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "releases",
                                name: "release-documents",
                                component: () => import("../views/app/release/release/release/ReleaseList"),
                                props: route => ({
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "samplings",
                                name: "sampling-documents",
                                component: () => import("../views/app/release/sampling/sampling/SamplingList"),
                                props: route => ({
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "send-samplings",
                                name: "send-sampling-documents",
                                component: () => import("../views/app/release/send-sampling/send-sampling/SendSamplingList"),
                                props: route => ({
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "analysiss",
                                name: "sampling-analysis-documents",
                                component: () => import("../views/app/release/sampling-analysis/sampling-analysis/SamplingAnalysisList"),
                                props: route => ({
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "sequestrates",
                                name: "sequestrate-documents",
                                component: () => import("../views/app/release/sequestrate/sequestrate/SequestrateList"),
                                props: route => ({
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "cancel-sequestrates",
                                name: "cancel-sequestrate-documents",
                                component: () => import("../views/app/release/cancel-sequestrate/cancel-sequestrate/CancelSequestrateList"),
                                props: route => ({
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                    // {
                    //     path: "request-receives",
                    //     redirect: { name: "release-request-receives" },
                    //     component: RouteView,
                    //     children: [
                    //         {
                    //             path: "",
                    //             name: "release-request-receives",
                    //             component: () => import("../views/app/release/request/RequestList"),
                    //             props: route => ({
                    //                 routerPrefix: "release-request-receives",
                    //                 ...JSON.parse(route.params?.props || null)
                    //             })
                    //         },
                    //         {
                    //             path: "create",
                    //             name: "release-request-receives-create",
                    //             component: () => import("../views/app/release/request/RequestForm"),
                    //             props: route => ({
                    //                 routerPrefix: "release-request-receives",
                    //                 ...JSON.parse(route.params?.props || null)
                    //             })
                    //         },
                    //         {
                    //             path: ":id/edit",
                    //             name: "release-request-receives-edit",
                    //             component: () => import("../views/app/release/request/RequestForm"),
                    //             props: route => ({
                    //                 routerPrefix: "release-request-receives",
                    //                 ...JSON.parse(route.params?.props || null)
                    //             })
                    //         },
                    //         {
                    //             path: ":id/view",
                    //             name: "release-request-receives-view",
                    //             component: () => import("../views/app/release/request/RequestForm"),
                    //             props: route => ({
                    //                 viewOnly: true,
                    //                 routerPrefix: "release-request-receives",
                    //                 ...JSON.parse(route.params?.props || null)
                    //             })
                    //         }
                    //     ]
                    // },
                    // {
                    //     path: "request-approves",
                    //     redirect: { name: "release-request-approves" },
                    //     component: RouteView,
                    //     children: [
                    //         {
                    //             path: "",
                    //             name: "release-request-approves",
                    //             component: () => import("../views/app/release/request/RequestApproveList"),
                    //             props: route => ({ ...JSON.parse(route.params?.props || null) })
                    //         },
                    //         {
                    //             path: "create",
                    //             name: "release-request-approves-create",
                    //             component: () => import("../views/app/release/request/RequestForm"),
                    //             props: route => ({
                    //                 routerPrefix: "release-request-approves",
                    //                 ...JSON.parse(route.params?.props || null)
                    //             })
                    //         },
                    //         {
                    //             path: ":id/edit",
                    //             name: "release-request-approves-edit",
                    //             component: () => import("../views/app/release/request/RequestForm"),
                    //             props: route => ({
                    //                 routerPrefix: "release-request-approves",
                    //                 ...JSON.parse(route.params?.props || null)
                    //             })
                    //         },
                    //         {
                    //             path: ":id/view",
                    //             name: "release-request-approves-view",
                    //             component: () => import("../views/app/release/request/RequestForm"),
                    //             props: route => ({
                    //                 viewOnly: true,
                    //                 routerPrefix: "release-request-approves",
                    //                 ...JSON.parse(route.params?.props || null)
                    //             })
                    //         }
                    //     ]
                    // }
                ]
            },
            {
                path: "fee",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "fee",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "fees",
                        redirect: { name: "fees" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "fees",
                                component: () => import("../views/app/fee/fee/FeeList"),
                                props: route => ({
                                    routerPrefix: "fees",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "fees-view",
                                component: () => import("../views/app/fee/fee/FeeForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "fees",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "fees-edit",
                                component: () => import("../views/app/fee/fee/FeeForm"),
                                props: route => ({
                                    routerPrefix: "fees",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "fee-receives",
                        redirect: { name: "fee-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "fee-receives",
                                component: () => import("../views/app/fee/fee/FeeList"),
                                props: route => ({
                                    routerPrefix: "fee-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "fee-receives-create",
                                component: () => import("../views/app/fee/fee/FeeForm"),
                                props: route => ({
                                    routerPrefix: "fee-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "fee-receives-edit",
                                component: () => import("../views/app/fee/fee/FeeForm"),
                                props: route => ({
                                    routerPrefix: "fee-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "fee-receives-view",
                                component: () => import("../views/app/fee/fee/FeeForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "fee-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "fee-approves",
                        redirect: { name: "fee-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "fee-approves",
                                component: () => import("../views/app/fee/fee/FeeApproveList"),
                                props: route => ({
                                    routerPrefix: "fee-approves",
                                    ...JSON.parse(route.params?.props || null),
                                    visibleApprove: true
                                })
                            },
                            {
                                path: "create",
                                name: "fee-approves-create",
                                component: () => import("../views/app/fee/fee/FeeForm"),
                                props: route => ({
                                    routerPrefix: "fee-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "fee-approves-edit",
                                component: () => import("../views/app/fee/fee/FeeForm"),
                                props: route => ({
                                    routerPrefix: "fee-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "fee-approves-view",
                                component: () => import("../views/app/fee/fee/FeeForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "fee-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "receipts",
                        redirect: { name: "receipts" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "receipts",
                                component: () => import("../views/app/fee/fee/FeeApproveList"),
                                props: route => ({
                                    routerPrefix: "receipts",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "receipts-create",
                                component: () => import("../views/app/fee/fee/FeeForm"),
                                props: route => ({
                                    routerPrefix: "receipts",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "receipts-edit",
                                component: () => import("../views/app/fee/fee/FeeForm"),
                                props: route => ({
                                    routerPrefix: "receipts",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "receipts-view",
                                component: () => import("../views/app/fee/fee/FeeForm"),
                                props: route => ({
                                    routerPrefix: "receipts",
                                    viewOnly: true,
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "haz-discuss",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "haz-discuss",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "haz-discusses",
                        redirect: { name: "haz-discusses" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-discusses",
                                component: () => import("../views/app/haz-discuss/haz-discuss/HazDiscussList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "haz-discusses-create",
                                component: () => import("../views/app/haz-discuss/haz-discuss/HazDiscussForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-discusses-edit",
                                component: () => import("../views/app/haz-discuss/haz-discuss/HazDiscussForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "haz-discusses-view",
                                component: () => import("../views/app/haz-discuss/haz-discuss/HazDiscussForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "haz-discuss-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-discuss-requests",
                                component: () => import("../views/app/haz-discuss/request/RequestList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "haz-discuss-requests-create",
                                component: () => import("../views/app/haz-discuss/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-discuss-requests-edit",
                                component: () => import("../views/app/haz-discuss/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "haz-discuss-requests-view",
                                component: () => import("../views/app/haz-discuss/request/RequestForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "haz-discuss-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-discuss-request-receives",
                                component: () => import("../views/app/haz-discuss/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "haz-discuss-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-discuss-request-receives-create",
                                component: () => import("../views/app/haz-discuss/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-discuss-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-discuss-request-receives-edit",
                                component: () => import("../views/app/haz-discuss/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-discuss-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-discuss-request-receives-view",
                                component: () => import("../views/app/haz-discuss/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-discuss-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "haz-discuss-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-discuss-request-approves",
                                component: () => import("../views/app/haz-discuss/request/RequestApproveList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "haz-discuss-request-approves-create",
                                component: () => import("../views/app/haz-discuss/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-discuss-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-discuss-request-approves-edit",
                                component: () => import("../views/app/haz-discuss/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "haz-discuss-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-discuss-request-approves-view",
                                component: () => import("../views/app/haz-discuss/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-discuss-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "manufacture-sample",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "manufacture-sample",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "manufacture-samples",
                        redirect: { name: "manufacture-samples" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "manufacture-samples",
                                component: () => import("../views/app/manufacture-sample/manufacture-sample/ManufactureSampleList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "manufacture-samples-create",
                                component: () => import("../views/app/manufacture-sample/manufacture-sample/ManufactureSampleForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "manufacture-samples-edit",
                                component: () => import("../views/app/manufacture-sample/manufacture-sample/ManufactureSampleForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "manufacture-samples-view",
                                component: () => import("../views/app/manufacture-sample/manufacture-sample/ManufactureSampleForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "manufacture-sample-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "manufacture-sample-requests",
                                component: () => import("../views/app/manufacture-sample/request/RequestList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "manufacture-sample-requests-create",
                                component: () => import("../views/app/manufacture-sample/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "manufacture-sample-requests-edit",
                                component: () => import("../views/app/manufacture-sample/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "manufacture-sample-requests-view",
                                component: () => import("../views/app/manufacture-sample/request/RequestForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "manufacture-sample-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "manufacture-sample-request-receives",
                                component: () => import("../views/app/manufacture-sample/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "manufacture-sample-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "manufacture-sample-request-receives-create",
                                component: () => import("../views/app/manufacture-sample/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-sample-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "manufacture-sample-request-receives-edit",
                                component: () => import("../views/app/manufacture-sample/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-sample-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "manufacture-sample-request-receives-view",
                                component: () => import("../views/app/manufacture-sample/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "manufacture-sample-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "manufacture-sample-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "manufacture-sample-request-approves",
                                component: () => import("../views/app/manufacture-sample/request/RequestApproveList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "manufacture-sample-request-approves-create",
                                component: () => import("../views/app/manufacture-sample/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-sample-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "manufacture-sample-request-approves-edit",
                                component: () => import("../views/app/manufacture-sample/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "manufacture-sample-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "manufacture-sample-request-approves-view",
                                component: () => import("../views/app/manufacture-sample/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "manufacture-sample-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "haz-mgt",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "haz-mgt",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "sells",
                        redirect: { name: "haz-mgt-sells" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-mgt-sells",
                                component: () => import("../views/app/haz-mgt/sell/SellList"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-sells",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-mgt-sells-create",
                                component: () => import("../views/app/haz-mgt/sell/SellForm"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-sells",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-mgt-sells-edit",
                                component: () => import("../views/app/haz-mgt/sell/SellForm"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-sells",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-mgt-sells-view",
                                component: () => import("../views/app/haz-mgt/sell/SellForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-mgt-sells",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "buys",
                        redirect: { name: "haz-mgt-buys" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-mgt-buys",
                                component: () => import("../views/app/haz-mgt/buy/BuyList"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-buys",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-mgt-buys-create",
                                component: () => import("../views/app/haz-mgt/buy/BuyForm"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-buys",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-mgt-buys-edit",
                                component: () => import("../views/app/haz-mgt/buy/BuyForm"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-buys",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-mgt-buys-view",
                                component: () => import("../views/app/haz-mgt/buy/BuyForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-mgt-buys",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "transfers",
                        redirect: { name: "haz-mgt-transfers" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-mgt-transfers",
                                component: () => import("../views/app/haz-mgt/transfer/TransferList"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-transfers",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-mgt-transfers-create",
                                component: () => import("../views/app/haz-mgt/transfer/TransferForm"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-transfers",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-mgt-transfers-edit",
                                component: () => import("../views/app/haz-mgt/transfer/TransferForm"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-transfers",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-mgt-transfers-view",
                                component: () => import("../views/app/haz-mgt/transfer/TransferForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-mgt-transfers",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "manufactures",
                        redirect: { name: "haz-mgt-manufactures" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-mgt-manufactures",
                                component: () => import("../views/app/haz-mgt/manufacture/ManufactureList"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-manufactures",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "haz-mgt-manufactures-create",
                                component: () => import("../views/app/haz-mgt/manufacture/ManufactureForm"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-manufactures",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "haz-mgt-manufactures-edit",
                                component: () => import("../views/app/haz-mgt/manufacture/ManufactureForm"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-manufactures",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "haz-mgt-manufactures-view",
                                component: () => import("../views/app/haz-mgt/manufacture/ManufactureForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "haz-mgt-manufactures",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "stock-cards",
                        redirect: { name: "haz-mgt-stock-cards" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "haz-mgt-stock-cards",
                                component: () => import("../views/app/haz-mgt/stock-card/StockCardList"),
                                props: route => ({
                                    routerPrefix: "haz-mgt-stock-cards",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "free-sale",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "free-sale",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "free-sales",
                        redirect: { name: "free-sales" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "free-sales",
                                component: () => import("../views/app/free-sale/free-sale/FreeSaleList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "free-sales-create",
                                component: () => import("../views/app/free-sale/free-sale/FreeSaleForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "free-sales-edit",
                                component: () => import("../views/app/free-sale/free-sale/FreeSaleForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "free-sales-view",
                                component: () => import("../views/app/free-sale/free-sale/FreeSaleForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "free-sale-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "free-sale-requests",
                                component: () => import("../views/app/free-sale/request/RequestList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "free-sale-requests-create",
                                component: () => import("../views/app/free-sale/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/edit",
                                name: "free-sale-requests-edit",
                                component: () => import("../views/app/free-sale/request/RequestForm"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: ":id/view",
                                name: "free-sale-requests-view",
                                component: () => import("../views/app/free-sale/request/RequestForm"),
                                props: route => ({ viewOnly: true, ...JSON.parse(route.params?.props || null) })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "free-sale-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "free-sale-request-receives",
                                component: () => import("../views/app/free-sale/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "free-sale-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "free-sale-request-receives-create",
                                component: () => import("../views/app/free-sale/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "free-sale-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "free-sale-request-receives-edit",
                                component: () => import("../views/app/free-sale/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "free-sale-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "free-sale-request-receives-view",
                                component: () => import("../views/app/free-sale/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "free-sale-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "free-sale-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "free-sale-request-approves",
                                component: () => import("../views/app/free-sale/request/RequestApproveList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "free-sale-request-approves-create",
                                component: () => import("../views/app/free-sale/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "free-sale-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "free-sale-request-approves-edit",
                                component: () => import("../views/app/free-sale/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "free-sale-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "free-sale-request-approves-view",
                                component: () => import("../views/app/free-sale/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "free-sale-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "hc",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "hc",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "hcs",
                        redirect: { name: "hcs" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "hcs",
                                component: () => import("../views/app/hc/hc/HcList"),
                                props: route => ({
                                    routerPrefix: "hcs",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "hcs-view",
                                component: () => import("../views/app/hc/hc/HcForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "hcs",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "hc-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "hc-requests",
                                component: () => import("../views/app/hc/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "hc-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "hc-requests-create",
                                component: () => import("../views/app/hc/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "hc-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "hc-requests-edit",
                                component: () => import("../views/app/hc/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "hc-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "hc-requests-view",
                                component: () => import("../views/app/hc/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "hc-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "hc-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "hc-request-receives",
                                component: () => import("../views/app/hc/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "hc-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "hc-request-receives-create",
                                component: () => import("../views/app/hc/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "hc-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "hc-request-receives-edit",
                                component: () => import("../views/app/hc/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "hc-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "hc-request-receives-view",
                                component: () => import("../views/app/hc/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "hc-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "to-whom",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "to-whom",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "to-whoms",
                        redirect: { name: "to-whoms" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "to-whoms",
                                component: () => import("../views/app/to-whom/to-whom/ToWhomList"),
                                props: route => ({
                                    routerPrefix: "to-whoms",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "to-whoms-view",
                                component: () => import("../views/app/to-whom/to-whom/ToWhomForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "to-whoms",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "requests",
                        redirect: { name: "to-whom-requests" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "to-whom-requests",
                                component: () => import("../views/app/to-whom/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "to-whom-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "to-whom-requests-create",
                                component: () => import("../views/app/to-whom/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "to-whom-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "to-whom-requests-edit",
                                component: () => import("../views/app/to-whom/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "to-whom-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "to-whom-requests-view",
                                component: () => import("../views/app/to-whom/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "to-whom-requests",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-receives",
                        redirect: { name: "to-whom-request-receives" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "to-whom-request-receives",
                                component: () => import("../views/app/to-whom/request/RequestList"),
                                props: route => ({
                                    routerPrefix: "to-whom-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "create",
                                name: "to-whom-request-receives-create",
                                component: () => import("../views/app/to-whom/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "to-whom-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "to-whom-request-receives-edit",
                                component: () => import("../views/app/to-whom/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "to-whom-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "to-whom-request-receives-view",
                                component: () => import("../views/app/to-whom/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "to-whom-request-receives",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    },
                    {
                        path: "request-approves",
                        redirect: { name: "to-whom-request-approves" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "to-whom-request-approves",
                                component: () => import("../views/app/to-whom/request/RequestApproveList"),
                                props: route => ({ ...JSON.parse(route.params?.props || null) })
                            },
                            {
                                path: "create",
                                name: "to-whom-request-approves-create",
                                component: () => import("../views/app/to-whom/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "to-whom-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/edit",
                                name: "to-whom-request-approves-edit",
                                component: () => import("../views/app/to-whom/request/RequestForm"),
                                props: route => ({
                                    routerPrefix: "to-whom-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: ":id/view",
                                name: "to-whom-request-approves-view",
                                component: () => import("../views/app/to-whom/request/RequestForm"),
                                props: route => ({
                                    viewOnly: true,
                                    routerPrefix: "to-whom-request-approves",
                                    ...JSON.parse(route.params?.props || null)
                                })
                            }
                        ]
                    }
                ]
            },
            {
                path: "nsw",
                redirect: { name: "transfer-declarations" },
                component: RouteView,
                children: [
                    {
                        path: "transfer-declarations",
                        name: "transfer-declarations",
                        component: () => import("../views/app/transfer-declaration/TransferDeclarationList"),
                        props: route => ({ ...JSON.parse(route.params?.props || null) })
                    }
                ]
            },
            {
                path: "report",
                component: RouteView,
                children: [
                    {
                        path: "",
                        name: "report",
                        component: () => import("../views/menu-list/MenuList"),
                        meta: { isAuth: true }
                    },
                    {
                        path: "reports",
                        redirect: { name: "reports" },
                        component: RouteView,
                        children: [
                            {
                                path: "",
                                name: "reports",
                                component: () => import("../views/app/report2/report/ReportList"),
                                props: route => ({
                                    ...JSON.parse(route.params?.props || null)
                                })
                            },
                            {
                                path: "login",
                                redirect: { name: "report-login" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-login",
                                        component: () => import("../views/app/report2/login/LoginList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "edit",
                                redirect: { name: "report-edit" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-edit",
                                        component: () => import("../views/app/report2/edit/EditList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "loginDuration",
                                redirect: { name: "report-login-duration" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-login-duration",
                                        component: () => import("../views/app/report2/loginDuration/LoginDurationList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "docDuration",
                                redirect: { name: "report-doc-duration" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-doc-duration",
                                        component: () => import("../views/app/report2/docDuration/DocDurationList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazO1",
                                redirect: { name: "report-hazO1" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-hazO1",
                                        component: () => import("../views/app/report2/hazO1/HazO1List"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazO4",
                                redirect: { name: "report-hazO4" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-hazO4",
                                        component: () => import("../views/app/report2/hazO4/HazO4List"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "manufactureSample",
                                redirect: { name: "report-manufacture-sample" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-manufacture-sample",
                                        component: () => import("../views/app/report2/manufacture-sample/ManufactureSampleList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "freeSale",
                                redirect: { name: "report-free-sale" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-free-sale",
                                        component: () => import("../views/app/report2/free-sale/FreeSaleList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazDiscuss",
                                redirect: { name: "report-haz-discuss" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-discuss",
                                        component: () => import("../views/app/report2/haz-discuss/HazDiscussList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "importSample",
                                redirect: { name: "report-import-sample" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-import-sample",
                                        component: () => import("../views/app/report2/import-sample/ImportSampleList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "storageLocation",
                                redirect: { name: "report-storage-location" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-storage-location",
                                        component: () => import("../views/app/report2/storage-location/StorageLocationList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "manufactureLocation",
                                redirect: { name: "report-manufacture-location" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-manufacture-location",
                                        component: () => import("../views/app/report2/manufacture-location/ManufactureLocationList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazLicenseS3O1",
                                redirect: { name: "report-haz-licenseS3" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-licenseS3",
                                        component: () => import("../views/app/report2/haz-licenseS3/HazLicenseS3List"),
                                        props: route => ({
                                            operationKey: "1",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazLicenseS3O2",
                                redirect: { name: "report-haz-licenseS3O2" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-licenseS3O2",
                                        component: () => import("../views/app/report2/haz-licenseS3/HazLicenseS3List"),
                                        props: route => ({
                                            operationKey: "2",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazLicenseS3O4",
                                redirect: { name: "report-haz-licenseS3O4" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-licenseS3O4",
                                        component: () => import("../views/app/report2/haz-licenseS3/HazLicenseS3List"),
                                        props: route => ({
                                            operationKey: "4",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazLicenseS3O5",
                                redirect: { name: "report-haz-licenseS3O5" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-licenseS3O5",
                                        component: () => import("../views/app/report2/haz-licenseS3/HazLicenseS3List"),
                                        props: route => ({
                                            operationKey: "5",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazLicenseS2O1",
                                redirect: { name: "report-haz-licenseS2" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-licenseS2",
                                        component: () => import("../views/app/report2/haz-licenseS2/HazLicenseS2List"),
                                        props: route => ({
                                            operationKey: "1",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazLicenseS2O2",
                                redirect: { name: "report-haz-licenseS2O2" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-licenseS2O2",
                                        component: () => import("../views/app/report2/haz-licenseS2/HazLicenseS2List"),
                                        props: route => ({
                                            operationKey: "2",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazLicenseS2O4",
                                redirect: { name: "report-haz-licenseS2O4" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-licenseS2O4",
                                        component: () => import("../views/app/report2/haz-licenseS2/HazLicenseS2List"),
                                        props: route => ({
                                            operationKey: "4",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazLicenseS2O5",
                                redirect: { name: "report-haz-licenseS2O5" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-licenseS2O5",
                                        component: () => import("../views/app/report2/haz-licenseS2/HazLicenseS2List"),
                                        props: route => ({
                                            operationKey: "5",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "informO1",
                                redirect: { name: "report-informO1" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-informO1",
                                        component: () => import("../views/app/report2/informO1/InformO1List"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "informO2",
                                redirect: { name: "report-informO2" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-informO2",
                                        component: () => import("../views/app/report2/informO2/InformO2List"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "passS12",
                                redirect: { name: "report-passS12" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-passS12",
                                        component: () => import("../views/app/report2/passS12/PassS12List"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "passS3",
                                redirect: { name: "report-passS3" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-passS3",
                                        component: () => import("../views/app/report2/passS3/PassS3List"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "inspection",
                                redirect: { name: "report-inspection" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-inspection",
                                        component: () => import("../views/app/report2/inspection/InspectionList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "release",
                                redirect: { name: "report-release" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-release",
                                        component: () => import("../views/app/report2/release/ReleaseList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazMgtSellBuy",
                                redirect: { name: "report-haz-mgt-sell-buy" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-mgt-sell-buy",
                                        component: () => import("../views/app/report2/haz-mgt/sell-buy/HazMgtSellBuyList"),
                                        props: route => ({
                                            mgtType: "sell-buy",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazMgtTransfer",
                                redirect: { name: "report-haz-mgt-transfer" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-mgt-transfer",
                                        component: () => import("../views/app/report2/haz-mgt/transfer/HazMgtTransferList"),
                                        props: route => ({
                                            mgtType: "transfer",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hazMgtManufacture",
                                redirect: { name: "report-haz-mgt-manufacture" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-haz-mgt-manufacture",
                                        component: () => import("../views/app/report2/haz-mgt/manufacture/HazMgtManufactureList"),
                                        props: route => ({
                                            mgtType: "manufacture",
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "toWhom",
                                redirect: { name: "report-to-whom" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-to-whom",
                                        component: () => import("../views/app/report2/to-whom/ToWhomList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "hc",
                                redirect: { name: "report-hc" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-hc",
                                        component: () => import("../views/app/report2/hc/HcList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "fee",
                                redirect: { name: "report-fee" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-fee",
                                        component: () => import("../views/app/report2/fee/FeeList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "ktb",
                                redirect: { name: "report-ktb" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-ktb",
                                        component: () => import("../views/app/report2/ktb/KtbList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "ktbPaynet",
                                redirect: { name: "report-ktb-paynet" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-ktb-paynet",
                                        component: () => import("../views/app/report2/ktb-paynet/KtbPaynetList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            },
                            {
                                path: "ktbPaymentOutputFile",
                                redirect: { name: "report-ktb-payment-output-file" },
                                component: RouteView,
                                children: [
                                    {
                                        path: "",
                                        name: "report-ktb-payment-output-file",
                                        component: () => import("../views/app/report2/ktb-payment-output-file/KtbPaymentOutputFileList"),
                                        props: route => ({
                                            ...JSON.parse(route.params?.props || null)
                                        })
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    },
    {
        path: "/account",
        name: "account",
        redirect: { name: "login" },
        meta: { isPublic: true },
        component: () => import("../components/layout/account-layout/AccountLayout"),
        children: [
            {
                path: "login",
                name: "login",
                meta: { isPublic: true },
                component: () => import("../views/account/login/Login")
            },
            {
                path: "forgot-password",
                name: "forgot-password",
                meta: { isPublic: true },
                component: () => import("../views/account/login/ForgotPassword")
            },
            {
                path: "active-forgot-password",
                name: "active-forgot-password",
                meta: { isPublic: true },
                component: () => import("../views/account/login/ActiveForgotPassword")
            }
        ]
    },
    {
        path: "/register",
        name: "register",
        meta: { isPublic: true },
        component: () => import("../views/account/register/Register")
    },
    {
        path: "/register-officer",
        name: "register-officer",
        meta: { isPublic: true },
        component: () => import("../views/account/register-officer/RegisterOfficer")
    },
    {
        path: "/requests/short-details",
        name: "request-short-details",
        meta: { isPublic: true },
        component: () => import("../views/app/request-short-detail/ShortDetailList.vue")
    },
    {
        path: "/requests/short-detail/:id",
        name: "request-short-detail",
        meta: { isPublic: true },
        component: () => import("../views/app/request-short-detail/RequestShortDetail")
    },
    {
        path: "/403",
        name: "403",
        meta: { isPublic: true },
        component: () => import("../views/error/403")
    },
    {
        path: "/500",
        name: "500",
        meta: { isPublic: true },
        component: () => import("../views/error/500")
    },
    {
        path: "/:pathMatch(.*)*",
        name: "404",
        meta: { isPublic: true },
        component: () => import("../views/error/404")
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes: routeData
});

const clearCacheQuery = (to, from, roleMenus) => {
    const menuContext = matchMenu(from.path, roleMenus);
    if (menuContext && menuContext.query) {
        if (menuContext.query.cacheQuery !== "true") {
            menuContext.query = null;
        }
    }
};

router.beforeEach((to, from, next) => {
    let allow = false;
    if (to.meta.isPublic) {
        allow = true;
    }
    if (to?.path !== from?.path) {
        setIsLoading(true);
    }
    const getRoleMenu = ref(null);
    const isAuth = store.getters["resource/auth/isAuth"];
    if (to.meta.isAuth && isAuth) {
        allow = true;
    }
    if (isAuth) {
        getRoleMenu.value = store.dispatch("resource/auth/getInfo", {});
        store.dispatch("resource/auth/setIntervalLogout", {});
    } else {
        getRoleMenu.value = store.dispatch("resource/anonymous/getInfo", {});
    }
    getRoleMenu.value
        .then(info => {
            stateApp.authInfo = info;
            const roleMenus = info.menus;
            clearCacheQuery(to, from, roleMenus);
            const match = matchMenu(to.path, roleMenus);
            stateApp.menuContext = match;
            if (allow) {
                next();
            } else if (!match) {
                if (isAuth) {
                    next({ name: "403", query: { url: from.fullPath } });
                } else {
                    next({ name: "login", query: { url: to.fullPath } });
                }
            } else {
                if (Object.keys(to.query).length > 0) {
                    match.query = to.query;
                }
                next();
            }
        })
        .finally(() => {
            clearModal();
            setTimeout(() => setIsLoading(false, 500));
        });
});

export { router as default, routeData };
